import ResponsiveAntdTable, { ResponsiveAntdTableProps } from "@/Components/ResponsiveAntdTable";
import { IPagina } from "@/Models/Utils/Pagina/Pagina";
import { TablePaginationConfig } from "antd";
import { AnyObject } from "antd/lib/_util/type";

export interface ITablePaginadaBasicProps<RecordType extends AnyObject, DataIndexType extends AnyObject = RecordType>
    extends Omit<ResponsiveAntdTableProps<RecordType, DataIndexType>, "dataSource"> {
    dataSource?: IPagina<RecordType>;
}

export default function TablePaginadaBasic<RecordType extends AnyObject = any, DataIndexType extends AnyObject = RecordType>({
    dataSource,
    pagination,
    ...props
}: ITablePaginadaBasicProps<RecordType, DataIndexType>) {
    const { pagina, tamanho, totalRegistros, registros } = dataSource ?? {};

    return (
        <ResponsiveAntdTable<RecordType, DataIndexType>
            {...props}
            dataSource={registros}
            pagination={{
                ...pagination,
                current: pagina,
                pageSize: tamanho,
                total: totalRegistros,
                showQuickJumper:
                    (pagination as TablePaginationConfig)?.showQuickJumper === undefined ? true : (pagination as TablePaginationConfig)?.showQuickJumper,
            }}
        />
    );
}